// src/hoc/withPaymentCheck.js
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

export function withPaymentCheck(WrappedComponent) {
  @inject('notesStore', 'routerStore')
  @observer
  class WithPaymentCheck extends Component {
    componentDidMount() {
      this.checkPaymentStatus();
    }

    componentDidUpdate() {
      this.checkPaymentStatus();
    }

    checkPaymentStatus = async () => {
      const { notesStore } = this.props;
      const paymentPlan = await notesStore.getPaymentPlan();

      if (!paymentPlan || paymentPlan.data === 'VOID') {
        console.log('No payment plan found');
        // Redirect to payment page if no payment plan
        window.location.hash = '/payment';
      }
    };

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithPaymentCheck;
}
